import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";

import { SPECIAL_PRIZES_FIELD_NAMES } from "../../../../../configurations/components/ConfigurationsPage/NewConfigurationPage/SpecialPrizesConfigurationSection/FormBuild/SpecialPrizesConfigurationSection.constants";
import { PROGRESSIVES_FIELD_NAMES } from "../../../../../configurations/components/ConfigurationsPage/NewConfigurationPage/ProgressivesConfigurationSection/FormBuild/ProgressivesConfigurationSection.constants";
import { subsidiaryDenominations } from "../../../../../../utils/addressUtils";
import { hallsStoreSelectors } from "../../../../store/store";
import { HallBaseConfig } from "../../../../reducers/hallsList.reducer";

export interface ProgressiveCompareProps {
    configsToCompare: any[];
    selectedForComparison: number[];
    objectKey: string;
    title: string;
    inspectingHall: HallBaseConfig;
}

const SECTIONS_KEYS = {
    special_prizes: SPECIAL_PRIZES_FIELD_NAMES,
    progressives: PROGRESSIVES_FIELD_NAMES
};

const STATIC_KEYS = {
    type: value => {
        if (value == "mr_champion") {
            return "Mr Champion";
        } else if (value == "pig_boom") {
            return "Pig Boom";
        } else if (value == "proportional") {
            return "Proportional";
        } else if (value == "normal") {
            return "Normal";
        } else if (value == "fractionated") {
            return "Fractionated";
        } else if (value == "levels") {
            return "Levels";
        } else if (value == "multipots") {
            return "Mulipots";
        } else if (value == "jumbolink") {
            return "Jumbo Link";
        }else if (value == "reelstrike") {
            return "Reel Strike";
        } else if (value == "easylink") {
            return "EasyLink";
        } else if (value == "sap") {
            return "SAP";
        } else if (value == "luckytokenslink") {
            return "LuckyToken";
        }

        return undefined;
    }
};

class ProgressiveCompareComponent extends Component<
    ProgressiveCompareProps,
    {}
> {
    renderChildProgressive = (progressive, index, schema) => {
        return (
            <div className="child" key={index}>
                {Object.keys(progressive).map(key => {
                    if (
                        SECTIONS_KEYS.progressives.hasOwnProperty(key) &&
                        key !== "children" &&
                        key !== "type" &&
                        key !== "coin"
                    ) {
                        if (
                            (key == "game_groups" ||
                                key == "terminal_groups") &&
                            progressive[key].length == 0
                        ) {
                            return null;
                        } else {
                            return (
                                <React.Fragment key={`${index}-${key}`}>
                                    <div className="array-item-title">
                                        {
                                            SECTIONS_KEYS[this.props.objectKey][
                                                key
                                            ]
                                        }
                                    </div>
                                    <div className="array-item-value">
                                        {this.renderValue(
                                            progressive[key],
                                            key,
                                            this.checkIfNeedsConvert(
                                                key,
                                                schema,
                                                this.props.objectKey,
                                                progressive.type
                                            ),
                                            schema
                                        )}
                                    </div>
                                </React.Fragment>
                            );
                        }
                    }

                    return null;
                })}
            </div>
        );
    };

    renderPrize = (prize, index, schema) => {
        return (
            <div className="prize" key={index}>
                {Object.keys(prize).map(key => {
                    if (SECTIONS_KEYS.progressives.hasOwnProperty(key)) {
                        return (
                            <React.Fragment key={`${index}-${key}`}>
                                <div className="array-item-title">
                                    {SECTIONS_KEYS[this.props.objectKey][key]}
                                </div>
                                <div className="array-item-value">
                                    {this.renderValue(
                                        prize[key],
                                        key,
                                        this.checkIfNeedsConvert(
                                            key,
                                            schema,
                                            this.props.objectKey,
                                            "prize"
                                        ),
                                        schema
                                    )}
                                </div>
                            </React.Fragment>
                        );
                    } else {
                        return null;
                    }
                })}
            </div>
        );
    };

    renderValue = (object, key, needsToConvert, schema) => {
        let toRender = object;

        if (typeof object === "boolean") {
            toRender = object == true ? "Yes" : "No";
        } else if (
            object instanceof Array &&
            key !== "game_groups" &&
            key !== "terminal_groups"
        ) {
            if (key == "prizes") {
                toRender = object.map((prize, index) =>
                    this.renderPrize(prize, index, schema)
                );
            } else if (key == "children") {
                toRender = object.map((child, index) =>
                    this.renderChildProgressive(child, index, schema)
                );
            } else if (key == "coin") {
                toRender = (
                    <div className="bullets-select">
                        <div>
                            {object.map((coin, index) => {
                                return (
                                    <div key={index} className="bullet">
                                        {subsidiaryDenominations[
                                            this.props.inspectingHall.subsidiary.country.code.toUpperCase()
                                        ]((coin / 100).toString())}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                );
            } else {
                toRender = (
                    <ul>
                        {object.map((item, itemIndex) => (
                            <li key={itemIndex}>
                                {needsToConvert ? item / 100 : item}
                            </li>
                        ))}
                    </ul>
                );
            }
        } else if (STATIC_KEYS.hasOwnProperty(key)) {
            toRender = STATIC_KEYS[key](toRender);
        } else if (key == "game_groups" && object) {
            const GAME_TYPES = {
                0: "bingo",
                1: "spins",
                2: "lotto",
                3: "keno"
            };
            toRender = (
                <React.Fragment>
                    {object.map(group => {
                        return (
                            <div
                                className="game-group"
                                key={`${key}-${group.id}`}
                            >
                                <div>
                                    <span>Name </span>
                                    {group.name}
                                </div>
                                <div className="bullets-select">
                                    <div>
                                        <span>Games</span>
                                        {group.game_instances.map(gi => {
                                            if (gi) {
                                                return (
                                                    <div
                                                        key={gi.id}
                                                        className={`bullet ${
                                                            GAME_TYPES[gi.type]
                                                        }`}
                                                    >
                                                       {gi.name}
                                                    </div>
                                                );
                                            }
                                        })}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </React.Fragment>
            );
        } else if (
            key == "terminal_groups" &&
            object !== undefined &&
            object &&
            object.filter(el => {
                return el != undefined && el != null;
            }).length > 0
        ) {
            const objectoToUse = object.filter(el => {
                return el != undefined && el != null;
            });
            toRender = (
                <React.Fragment>
                    {objectoToUse.map(group => {
                        return (
                            <div
                                className="terminal-group"
                                key={`${key}-${group.id}`}
                            >
                                <div>
                                    <span>Name:</span>
                                    {group.id}
                                </div>
                                <div>
                                    <span>Description:</span>
                                    {group.description}
                                </div>
                            </div>
                        );
                    })}
                </React.Fragment>
            );
        }

        return toRender == undefined || toRender == null
            ? "-"
            : needsToConvert
            ? toRender / 100
            : toRender;
    };

    checkIfKeyExistsInAnyObject = (key, index) => {
        let exists = false;
        this.props.configsToCompare.map(config => {
            if (
                typeof config.progressives[index] !== "undefined" &&
                config.progressives[index].hasOwnProperty(key) &&
                ((config.progressives[index][key] !== null &&
                    !_.isArray(config.progressives[index][key])) ||
                    (_.isArray(config.progressives[index][key]) &&
                        config.progressives[index][key].length > 0))
            ) {
                exists = true;
            }
        });

        return exists;
    };

    checkIfNeedsConvert = (key, schema, objectKey, type) => {
        if (objectKey == "special_prizes") {
            let exactSchema = schema.schema.definitions[`$${type}`].properties;
            if (
                exactSchema.hasOwnProperty(key) &&
                exactSchema[key].hasOwnProperty("convert") &&
                exactSchema[key]["convert"] == true
            ) {
                return true;
            }
        } else if (objectKey == "progressives") {
            let exactSchema = undefined;

            if (type == "proportional" || type == "normal" || type == "fractionated") {
                exactSchema =
                    schema.schema.definitions[`$${type}_jackpot`].properties;
            } else if (
                type == "easylink" ||
                type == "multipots" ||
                type == "jumbolink" ||
                type == "luckytokenslink" ||
                type == "reelstrike" ||
                type == "levels" ||
                type == "sap"
            ) {
                exactSchema =
                    schema.schema.definitions[`$progressive`].properties;
            } /*else if (type == "levels") {
                exactSchema = schema.schema.definitions[`$levels`].properties;
            }*/ else if (type == "prize") {
                exactSchema =
                    schema.schema.definitions[`$progressive`].properties.prizes
                        .items.properties; // TODO Adapt for Levels
            }

            if (
                exactSchema !== undefined &&
                exactSchema.hasOwnProperty(key) &&
                exactSchema[key].hasOwnProperty("convert") &&
                exactSchema[key]["convert"] == true
            ) {
                return true;
            }
        }
        return false;
    };

    renderObjectAtIndex = (config, index, keys) => {
        return (
            <React.Fragment key={index}>
                {keys.map(key => {
                    if (
                        this.checkIfKeyExistsInAnyObject(key, index) &&
                        SECTIONS_KEYS.hasOwnProperty(this.props.objectKey) &&
                        SECTIONS_KEYS[this.props.objectKey].hasOwnProperty(key)
                    ) {
                        return (
                            <React.Fragment key={`${index}-${key}`}>
                                <div className="array-item-title">
                                    {SECTIONS_KEYS[this.props.objectKey][key]}
                                </div>
                                <div className="array-item-value">
                                    {this.renderValue(
                                        config.progressives[index][key],
                                        key,
                                        this.checkIfNeedsConvert(
                                            key,
                                            config.schema,
                                            this.props.objectKey,
                                            config.progressives[index].type
                                        ),
                                        config.schema
                                    )}
                                </div>
                            </React.Fragment>
                        );
                    }
                    return null;
                })}
            </React.Fragment>
        );
    };

    render() {
        let keys = [];
        let rowsCount = 0;

        this.props.configsToCompare.map(config => {
            if (config.progressives.length > rowsCount) {
                rowsCount = config.progressives.length;
            }

            config.progressives.map(item => {
                keys = keys.concat(Object.keys(item));
            });
        });

        keys = _.uniq(keys);

        const arrayRows = Array.from(Array(rowsCount).keys());

        return (
            <table id="table-comparative">
                <thead>
                    <tr>
                        <td colSpan={this.props.selectedForComparison.length}>
                            {this.props.title}
                        </td>
                    </tr>
                </thead>
                <tbody>
                    {arrayRows.map(index => {
                        return (
                            <tr key={index}>
                                {this.props.configsToCompare.map(
                                    (config, indexConfig) => {
                                        if (
                                            typeof config.progressives[
                                                index
                                            ] !== "undefined"
                                        ) {
                                            return (
                                                <td
                                                    key={`${index}-${indexConfig}`}
                                                    className="value progressive"
                                                >
                                                    {this.renderObjectAtIndex(
                                                        config,
                                                        index,
                                                        keys
                                                    )}
                                                </td>
                                            );
                                        } else {
                                            return (
                                                <td
                                                    key={index}
                                                    className="value"
                                                />
                                            );
                                        }
                                    }
                                )}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }
}

const mapStateToProps = state => ({
    inspectingHall: hallsStoreSelectors.inspectingHall(state)
});

const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProgressiveCompareComponent);
